import styled from "styled-components";
import colors from "frontend/src/constants/colors";
import { Link } from "react-router-dom";

export const FooterLink = styled(Link)`
  text-decoration: none;
  color: white;
  &:hover {
    color: ${colors.secondary};
  }
`;
